export const baseData = {
  title: "PRICE LEVEL CUSTOMER"
}